import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Home/Header";
import Home from "./components/Home/index";
import Footer from "./components/Footer";
import Services from "./components/Services/index";
import Blog from "./components/Blog/index";
import BlogSingle from "./components/Blog/BlogSingle";
import Shop from "./components/Shop/Shop";
import Checkout from "./components/Shop/Checkout";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Terms from "./components/Terms";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogSingle />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/checkout/:id" element={<Checkout />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
